"use strict";

exports.__esModule = true;

require('./level.css');

exports.default = {
  "level": "pf-l-level",
  "modifiers": {
    "gutter": "pf-m-gutter"
  }
};